import { Component, EventEmitter, Inject, Output, OnDestroy, inject } from '@angular/core'; 
import { OverlayRef } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { Observable, Subject, timer } from 'rxjs';
import { map, takeWhile, takeUntil } from 'rxjs/operators';
import { BaseConfigurableComponent } from '@app/base-config.component';
import { Appointment } from '@app/services/fetch/appointment';

@Component({
  selector: 'afcu-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './modal.component.html'
})
export class ModalComponent extends BaseConfigurableComponent implements OnDestroy {

  @Output() action = new EventEmitter<boolean>();
  countdownText$?: Observable<string>;

  private destroy$ = new Subject<void>();
  private appointmentService = inject(Appointment)

  constructor(
    @Inject(OverlayRef)           private overlayRef: OverlayRef,
    @Inject('action')             public  text: string,
    @Inject('secondsLeft')        private secondsLeft?: number
  ) {
    super('modal');

    if (this.text === 'timeout' && this.secondsLeft != null && this.secondsLeft > 0) {
      const template = this.getText().timeout; 
      const duration = this.secondsLeft;     

      this.countdownText$ = timer(0, 1000).pipe(
        map(i => duration - i),               
        takeWhile(s => s >= 0),                
        map(s => template.replace('{{ countdown }}', s.toString())), 
        takeUntil(this.destroy$)             
      );
    } else if (this.text === 'timeout') {
        const template = this.getText().timeout;
        this.countdownText$ = new Observable<string>(observer => {
            observer.next(template.replace('{{ countdown }}', '0'));
            observer.complete();
        });
    }
  }

  // For the "Goodbye" button
  goodbyeAction(): void {

    this.action.emit(false);
    
    if (this.text === 'timeout') {

      this.appointmentService.request.set(null)
      this.appointmentService.unhandledError.set(false)
      
      this.overlayRef.detach();
      
      try {
      } catch (error) {
        window.location.reload();
      }
    } else {
      // For non-timeout modals
      this.overlayRef.detach();
    }
  }

  // For "Still Here" and other buttons
  closeOverlay(ok: boolean): void {
    // For Goodbye button (false on timeout modal)
    if (!ok && this.text === 'timeout') {
      this.goodbyeAction();
      return;
    }
    
    this.action.emit(ok);
    this.overlayRef.detach();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}